import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space, Row, Col, InputNumber } from "antd";
import React, { useState, forwardRef, useEffect } from "react";
import { MdOutlineAttachMoney } from "react-icons/md";

const ProductPriceAttribute = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [attrRequired, setAttrRequired] = useState(false);

  const valueForm = {
    name: null,
    types: null,
  };

  const { productItem } = props;

  useEffect(() => {
    if (productItem) {
      if (productItem.variant) {
        form.setFieldsValue({
          name: productItem.variant?.name,
          types: productItem.variant?.types,
        });
        setAttrRequired(true);
      } else {
        form.setFieldsValue(valueForm);
      }
    } else {
      form.setFieldsValue(valueForm);
    }
  }, [form]);

  const onFinishFailed = (errorInfo) => {
    props.onFinishFailed({
      errorFields: errorInfo.errorFields,
      name: "ProductPriceAttribute",
    });
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    let payload = null;

    if (values.types && values.types.length) {
      payload = values;
    }
    const variant = {
      variant: payload,
    };
    props.onSubmit(variant, "ProductPriceAttribute");
  };

  return (
    <>
      <Row gutter={[24, 0]} align="center">
        <Col span={12}>
          <Form
            form={form}
            ref={ref}
            name="dynamic_form_nest_item"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
            onValuesChange={(values) => {
              setAttrRequired(values.types && values.types.length > 0);
            }}
            size="large"
          >
            <Form.Item
              label="Tên thuộc tính"
              name="name"
              tooltip="Tên của thuộc tính (vd : dung tích, khối lượng)"
              rules={[
                {
                  required: attrRequired,
                  message: "Vui lòng nhập tên thuộc tính !",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.List name="types" >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} align="baseline">
                      <Form.Item
                        {...restField}
                        label="Đơn vị thuộc tính"
                        name={[name, "name"]}
                        tooltip="Đơn vị của thuộc tính (vd : 500ml, 20kg)"
                        rules={[
                          {
                            required: true,
                            message: "Vui lòng nhập tên!",
                          },
                        ]}
                      >
                        <Input />
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        label="Giá"
                        name={[name, "price"]}
                        rules={[
                          {
                            required: true,
                            message: "Thiếu giá",
                          },
                        ]}
                      >
                        <InputNumber
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          addonAfter={<MdOutlineAttachMoney />}
                        />
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        initialValue="0"
                        label="Giá khuyến mãi"
                        name={[name, "salePrice"]}
                      >
                        <InputNumber
                          formatter={(value) =>
                            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }
                          parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                          addonAfter={<MdOutlineAttachMoney />}
                        />
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        label="Số lượng"
                        name={[name, "quantity"]}
                        rules={[
                          {
                            required: true,
                            message: "Thiếu số lượng",
                          },
                        ]}
                      >
                        <InputNumber min={0}/>
                      </Form.Item>

                      <Form.Item label={" "}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Form.Item>
                    </Space>
                  ))}

                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Thêm đơn vị thuộc tính
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form>
        </Col>
      </Row>
    </>
  );
});

export default ProductPriceAttribute;
